module.exports = __webpack_public_path__ + "img/IMG-20200901-WA0005.71b1efea.jpg";